import { toArray } from '@wix/wow-utils';
const name = 'SlideVertical';
const properties = {
    defaultDuration: 0.6,
    schema: {
        duration: {
            type: 'number',
            min: 0,
            default: 0,
        },
        delay: {
            type: 'number',
            min: 0,
            default: 0,
        },
        reverse: {
            type: 'boolean',
            default: false,
        },
        height: {
            type: 'number',
            min: 0,
        },
    },
};
/**
 * Slide an element out and another in from top to bottom.
 */
function transition(kit, sourceElements, destElements, duration, delay, { reverse = false, height, ease = 'Strong.easeInOut', ...params } = {}) {
    const direction = reverse ? -1 : 1;
    sourceElements = toArray(sourceElements);
    height = height ?? sourceElements[0].offsetHeight;
    const sequence = kit.sequence(params);
    sequence.add([
        kit.animate('BaseFade', destElements, 0, delay, {
            to: { opacity: 1 },
            immediateRender: false,
        }),
        kit.animate('BasePosition', sourceElements, duration, delay, {
            from: { y: 0 },
            to: { y: -height * direction },
            ease,
        }),
        kit.animate('BasePosition', destElements, duration, delay, {
            from: { y: height * direction },
            to: { y: 0 },
            ease,
        }),
    ]);
    return sequence.get();
}
export { name, properties, transition };
//# sourceMappingURL=slideVertical.js.map